<!--  -->
<template>
    <div class='About_ISFAL'>
        <div class="title_box">
            <img src="../../assets/images/isfal/bj_03.jpg" alt="">
        </div>
        <div class="Certification_System">
            <div class="Certification_System_box">
                <div class="System_box_1">
                    <div class="System_box_1_left">
                        <p class="System_box_1_left_1 " @click="onSystem">Certification System</p>
                        <p class="System_box_1_left_1 active" @click="onOfficers">Certification Officers</p>
                        <p class="System_box_1_left_1 " @click="onSearch" >Certificate Search</p>
                    </div>
                    <div class="System_box_1_right" >
                        <div class="cen_box_box_3" style="margin-top: 10px;">
                            <div class="cen_box_box_3_3" v-for="(item,index) in list" :key="index" @click="onExperts(item)">
                                <img :src="item.photo" alt="">
                                <p class="name">{{ item.name }}</p>
                                <p class="info">{{ item.info }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import "@/assets/css/About_ISFAL.less"
    export default {
        name: '',
        data() {
            //这里存放数据
            return {
                list:[
                    {
                        photo: require('@/assets/images/isfal/10021.png'),
                        name:"Christine Abbott",
                        info:"UK"
                    },
                    {
                        photo: require('@/assets/images/isfal/10022.png'),
                        name:"Dr. Michael Weiss",
                        info:"Austria"
                    },
                    {
                        photo: require('@/assets/images/isfal/10023.png'),
                        name:"Tang Changjun",
                        info:"China"
                    }
                ]
            }
        },
        components: {},

        //方法集合
        methods: {
            onExperts(){
                this.$router.push('/FoundersAndExperts')
            },
            onSystem(){
                this.$router.push('/Certification_System')
            },
            onOfficers(){
                this.$router.push('/Certification_Officers')
            },
            onSearch(){
                this.$router.push('/Certificate_Search')
            }
        },
        created() {

        },
        mounted() {

        }
    }
</script>
<style scoped>

</style>